var pdp_standard = $('.desktop-dimension span.pdp_standard, .dimension p.pdp_standard');
var pdp_twin = $('.desktop-dimension span.pdp_twin, .dimension p.pdp_twin');
var pdp_twinxl = $('.desktop-dimension span.pdp_twinxl, .dimension p.pdp_twinxl');
var pdp_full = $('.desktop-dimension span.pdp_full, .dimension p.pdp_full');
var pdp_queen = $('.desktop-dimension span.pdp_queen, .dimension p.pdp_queen');
var pdp_king = $('.desktop-dimension span.pdp_king, .dimension p.pdp_king');
var pdp_calking = $('.desktop-dimension span.pdp_calking, .dimension p.pdp_calking');
var pdp_shortqueen = $('.desktop-dimension span.pdp_shortqueen, .dimension p.pdp_shortqueen');
var pdp_splitking = $('.desktop-dimension span.pdp_splitking, .dimension p.pdp_splitking');
// console.log(dimension);
$('.o-select select').on('change', function() {
    var d_val = (this.value && this.value.toUpperCase()) || "";
    $(".d_change_show").addClass("d_change_hide").removeClass("d_change_show");
    switch(true) {
        case (d_val == 'TWIN' || d_val == "SIMPLE"): {
            pdp_twin.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'TWINXL' || d_val == "TWIN XL" || d_val == "SIMPLEXL" || d_val == "SIMPLE XL"): {
            pdp_twinxl.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'FULL'|| d_val == "DOUBLE"): {
            pdp_full.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'QUEEN'): {
            pdp_queen.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'KING'): {
            pdp_king.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'CALKING' || d_val == "CAL KING" || d_val == "KING CAL"): {
            pdp_calking.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'STANDARD'): {
            pdp_standard.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'SHORT QUEEN'): {
            pdp_shortqueen.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
        case (d_val == 'SPLIT KING'): {
            pdp_splitking.removeClass("d_change_hide").addClass('d_change_show');
            break;
        }
    }
});